import { render, staticRenderFns } from "./NawecRunningBalance.vue?vue&type=template&id=5180433c"
import script from "./NawecRunningBalance.vue?vue&type=script&lang=js"
export * from "./NawecRunningBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports